import { CheckoutPageModel, isCheckoutPage } from 'models/CheckoutPageModel';
import { withPage } from 'utils';
import { PageState } from 'models/PageState';
import { Summary } from 'models/Summary';
import { SummaryItem } from 'models/SummaryItem';
import { SummaryType } from 'models/SummaryType';

export const selectSummary: ({ currentPage }: PageState) => Summary | null = withPage(
  isCheckoutPage,
  (page: CheckoutPageModel) => page.summary
);

export const containsZipDependantItem = (summaryItem: SummaryItem): boolean =>
  summaryItem.type === SummaryType.ZipDependantFreight;
